import React, { Component } from 'react'
import styled from 'styled-components'
import bg from '../assets/img/bg2.jpg'
import Title from '../components/Title'
import { vw } from '../untils/styled'
import icon1 from '../assets/img/icon1.png'
import moment from 'moment'
import ReactEcharts from 'echarts-for-react'
import riskMap from '../assets/js/risklevel'
import { 
    DialogSubmitRes,
    DialogShare,
    DialogZBSM,
    DialogLucky,
    DialogFail,
    DialogSuccess
} from '../components/dialogs'
import { getQueryString } from '../untils'
import { ClientClickContent, ClientFinishCalcAssetAllocation } from '../untils/sa-event'
import Toast from 'react-toast-mobile'
import 'react-toast-mobile/lib/react-toast-mobile.css'

const Body = styled.div`
    width: 100%;
    background-image: url(${bg});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: left top;
    padding-bottom: ${vw(150)};
`

const MoneyWrapper = styled.div`
    width: 100%;
`

const MoneyTitle = styled.div`
    font-family: BigruixianBlackGB;
    width: ${vw(600)};
    margin: ${vw(30)} auto ${vw(20)};
    text-align: center;
    font-size: ${vw(75)};
    color: #fcd78b;

    span {
        display: inline-block;
        vertical-align: middle;
    }

    > span:first-of-type {
        width: ${vw(17)};
        height: ${vw(17)};
        background-color: #bf904d;
        opacity: 0.7;
        position: relative;
        border-radius: 50%;

        &:before {
            content: '';
            width: ${vw(12)};
            height: ${vw(12)};
            background-color: #bf904d;
            opacity: 0.4;
            position: absolute;
            border-radius: 50%;
            top: ${vw(3)};
            left: ${vw(-25)};
        }

        &:after {
            content: '';
            width: ${vw(7)};
            height: ${vw(7)};
            background-color: #bf904d;
            opacity: 0.2;
            position: absolute;
            border-radius: 50%;
            top: ${vw(5)};
            left: ${vw(-50)};
        }
    }

    > span:nth-of-type(2) {
        margin: 0 ${vw(15)};
    }

    > span:last-of-type {
        width: ${vw(17)};
        height: ${vw(17)};
        background-color: #bf904d;
        opacity: 0.7;
        position: relative;
        border-radius: 50%;

        &:before {
            content: '';
            width: ${vw(12)};
            height: ${vw(12)};
            background-color: #bf904d;
            opacity: 0.4;
            position: absolute;
            border-radius: 50%;
            top: ${vw(3)};
            right: ${vw(-25)};
        }

        &:after {
            content: '';
            width: ${vw(7)};
            height: ${vw(7)};
            background-color: #bf904d;
            opacity: 0.2;
            position: absolute;
            border-radius: 50%;
            top: ${vw(5)};
            right: ${vw(-50)};
        }
    }
`

const MoneyMain = styled.div`
    width: ${vw(610)};
    height: ${vw(200)};
    margin: 0 auto;

    > div:first-of-type {
        opacity: 0.67;
        color: #f4f4f4;
        font-size: ${vw(24)};
        padding: ${vw(15)} 0;
        margin-bottom: ${vw(34)};
    }
    > div:last-of-type {
        position: relative;
        color: #f8f8f8;
        opacity: 0.87;

        > span {
            display: inline-block;
            vertical-align: bottom;
        }

        > span:last-of-type {
            position: absolute;
            right: ${vw(60)};
            top: ${vw(15)};
            font-size: ${vw(70)}
        }
    }
`

const MoneyNumber = styled.span`
    display: block;
    width: ${vw(370)};
    height: ${vw(100)};
    line-height: ${vw(100)};
    text-align: center;
    position: absolute;
    left: ${vw(30)};
    font-family: DIGIFAW;
    font-size: ${props => vw(props.fontSize)};
`

const MoneyText = styled.div`
    font-family: PingFang-SC-Regular;
    font-size: ${vw(28)};
    width: ${vw(600)};
    margin: ${vw(37)} auto ${vw(10)};
    line-height: ${vw(48)};
    color: #fffcf7;
    opacity: 0.5;
    font-weight: 300;
`

const MoneyLink = styled.a`
    position: absolute;
    top: ${vw(840)};
    left: 50%;
    transform: translateX(-50%);
    color: #fcd78b;
    font-size: ${vw(24)};
    opacity: 0.5;
    appearance: none;
    font-weight: 100;
`

const SectionWrapper = styled.div`
    padding: 0 ${vw(30)};
`

const TitleWrapper = styled.div`
    padding-top: ${props => vw(props.pt)};
    margin-bottom: ${props => vw(props.mb || 0)};
`

const Contrast = styled.div`
	background-image: linear-gradient(152deg, 
		#434756 0%, 
		#363a45 100%);
    box-shadow: 0px 9px 32px 0px 
		rgba(33, 34, 41, 0.85);
    border-radius: 0px 0px 6px 6px;
    
    .tips {
        color: #fffcf7;
        opacity: 0.2;
        font-size: ${vw(24)};
        text-align: center;
        margin-top: ${vw(50)};
        padding-bottom: ${vw(40)};
    }
`

const Contrast1 = styled(Contrast)`
    padding: ${vw(45)} ${vw(20)} 0;

    .th {
        display: flex;
        font-size: ${vw(24)};
        color: #fcd78d;
        text-align: center;
        opacity: 0.9;

        span {
            flex: 1;
            position: relative;

            &:after {
                content: '';
                width: ${vw(25)};
                height: ${vw(25)};
                background: url(${icon1}) no-repeat;
                background-size: ${vw(25)} auto;
                position: absolute;
                right: ${vw(-10)};
                top: 50%;
                transform: translateY(-50%);
            }
        }

        span:first-of-type {
            &:after {
                background: transparent;
            }
        }

        span:nth-of-type(2) {
            &:after {
                right: ${vw(2)};
            }
        }

        span:nth-of-type(4) {
            &:after {
                right: ${vw(2)};
            }
        }
    }

    .td {
        display: flex;
        font-size: ${vw(28)};
        text-align: center;
        color: #fffcf7;
        opacity: 0.9;
        margin-top: ${vw(50)};

        span:first-of-type {
            font-size: ${vw(28)};
            color: #fcd78d;
        }

        span {
            flex: 1
        }
    }
`
const Contrast4 = styled(Contrast)`
    padding: ${vw(55)} ${vw(35)} ${vw(55)} ${vw(65)};
    font-size: ${vw(26)};
    line-height: ${vw(48)};
    color: #f4f4f4;
    opacity: 0.45;
    font-weight: 300;

    > div {
        position: relative;
        &::before {
            content: '';
            position: absolute;
            left: ${vw(-30)};
            top: ${vw(20)};
            width: ${vw(6)};
            height: ${vw(6)};
            background-color: #ffffff;
            border-radius: 50%;
            opacity: 0.45;
        }
    }
`

const BackButton = styled.div`
    font-size: ${vw(28)};
    text-align: center;
	color: #fcd78d;
    opacity: 0.6;
    margin: ${vw(40)} 0 ${vw(60)};
`

const FooterText = styled.div`
    font-size: ${vw(24)};
    line-height: ${vw(48)};
    color: #f4f4f4;
	opacity: 0.45;
`

const FooterButtonWrapper = styled.div`
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
`

const FooterButton = styled.div`
    flex: 1;
    height: ${vw(100)};
    line-height: ${vw(100)};
    text-align: center;
    color: #fff;
    font-size: ${vw(36)};
    background-image: ${props => props.orange ? 'linear-gradient(90deg, #ff793d 0%, #ff6a3b 50%, #ff5a39 100%)' : 'linear-gradient(90deg, #fcd78d 0%, #bd8e4c 100%)'};
`

const IsMaxValue = styled.span`
    color: ${props => props.max === 1 ? '#ff7d43' : '#fffcf7'};
`

export default class Result extends Component {
    constructor () {
        super()
        this.state = {
            dialogState: {}
        }
        this.scene = getQueryString('id') === '000'
        this.isIframe = window.self !== window.top
    }
    chartLineOption = () => {
        const dateList = () => {
            return this.props.nav.ZL.map(item => {
                return moment(item.workdate).format('YYYY/MM/DD')
            })
        }
        const navZL = () => {
            return this.props.nav.ZL.map(item => {
                return item.nav
            })
        }
        const navHS = () => {
            return this.props.nav.HS.map(item => {
                return item.nav
            })
        }
        const navKH = () => {
            return this.props.nav.KH.map(item => {
                return item.nav
            })
        }

        return {
            legend: {
                data: [
                    {
                        name: '您的配置',
                        icon: 'rect'
                    },
                    {
                        name: '众禄配置',
                        icon: 'rect'
                    },
                    {
                        name: '沪深300',
                        icon: 'rect'
                    }
                ],
                textStyle: {
                    color: '#fff'
                },
                bottom: 10
            },
            xAxis: {
                type: 'category',
                data: dateList(),
                splitLine: { show: false },//去除网格线
                axisLabel: {
                    textStyle: {
                        color: 'rgba(255, 255, 255, 0.2)'
                    },
                    fontFamily: '-apple-system,BlinkMacSystemFont,PingFang SC,Helvetica Neue,STHeiti,Microsoft Yahei,Tahoma,Simsun,sans-serif'
                },
                axisLine: {
                    color: '#31343e'
                }
            },
            yAxis: [{
                splitLine: {
                    lineStyle: {
                        color: '#31343e'
                    }
                },
                type: 'value',
                axisLabel: {
                    interval: 10,
                    color: 'rgba(255, 255, 255, 0.2)'
                },
                axisLine: {
                    show: false
                }
            }],
            grid: {
                left: 40
            },
            series: [{
                name: '众禄配置',
                type: 'line',
                itemStyle: {
                    normal: {
                        color: '#fcd78d'
                    }
                },
                lineStyle: {
                    width: 1
                },
                data: navZL()
            }, {
                name: '沪深300',
                type: 'line',
                itemStyle: {
                    normal: {
                        color: '#7f88a3'
                    }
                },
                lineStyle: {
                    width: 1
                },
                data: navHS()
            }, {
                name: '您的配置',
                type: 'line',
                itemStyle: {
                    normal: {
                        color: '#ff7d43'
                    }
                },
                lineStyle: {
                    width: 1
                },
                data: navKH()
            }]
        }
    }
    chartBarOption = () => {
        const calcAror = () => {
            return [this.props.calc.aror, this.props.calc.arorZl, this.props.calc.arorHs300]
        }
        const calcSharperatio = () => {
            return [this.props.calc.sharperatio, this.props.calc.sharperatioZl, this.props.calc.sharperatioHs300]
        }
        const calcMaxdrawdown = () => {
            return [this.props.calc.maxdrawdown, this.props.calc.maxdrawdownZl, this.props.calc.maxdrawdownHs300]
        }

        return {
            legend: {
                data: [
                    {
                        name: '夏普比率',
                        icon: 'rect'
                    },                    
                    {
                        name: '年化收益率',
                        icon: 'rect'
                    },
                    {
                        name: '最大回撤',
                        icon: 'rect'
                    }
                ],
                textStyle: {
                    color: 'rgba(255, 255, 255, 0.7)'
                },
                bottom: 0
            },
            xAxis: {
                type: 'category',
                data: ['您的配置', '众禄配置', '沪深300'],
                splitLine: { show: false },//去除网格线
                axisLabel: {
                    color: 'rgba(255, 255, 255, 1)',
                    fontFamily: 'Microsoft YaHei',
                    fontSize: 12
                },
                axisLine: {
                    color: '#31343e'
                }
            },
            yAxis: [{
                splitLine: {
                    lineStyle: {
                        color: '#31343e'
                    }
                },
                type: 'value',
                axisLabel: {
                    interval: 10,
                    color: 'rgba(255, 255, 255, 0.2)'
                },
                axisLine: {
                    show: false
                }
            }],
            grid: {
                left: 40
            },
            series: [{
                name: '年化收益率',
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: '#fcd78d',
                        label: {
                            show: true,
                            fontSize: 10,
                            position: 'top'
                        }
                    }
                },
                data: calcAror()
            }, {
                name: '夏普比率',
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: '#7f88a3',
                        label: {
                            show: true,
                            fontSize: 10,
                            position: 'top'
                        }
                    }
                },
                data: calcSharperatio()
            }, {
                name: '最大回撤',
                type: 'bar',
                itemStyle: {
                    normal: {
                        color: '#ff7d43',
                        label: {
                            show: true,
                            fontSize: 10,
                            position: 'bottom'
                        }
                    }
                },
                data: calcMaxdrawdown()
            }]
        }
    }
    backToCalculate = () => {
        ClientClickContent('返回重新计算');
        this.props.lastStep();
    }
    dialogCentre = (state, type) => {
        if (state) {
            switch (type) {
                case 'share':
                    ClientClickContent('分享')
                    this.setState({
                        dialogState: {
                            share: state
                        }
                    })
                    break;
                case 'submitRes':
                    ClientClickContent('赢取现场红包666元')
                    this.setState({
                        dialogState: {
                            submitRes: state
                        }
                    })
                    break;
                case 'ZBSM':
                    this.setState({
                        dialogState: {
                            ZBSM: state
                        }
                    })
                    break;
                case 'lucky':
                    this.setState({
                        dialogState: {
                            lucky: state
                        }
                    })
                    break;
                case 'fail':
                    this.setState({
                        dialogState: {
                            fail: state
                        }
                    })
                    break;
                case 'success':
                    this.setState({
                        dialogState: {
                            success: state
                        }
                    })
                    break;
                case 'getReport':
                    ClientClickContent('获取完整报告')
                    this.setState({
                        dialogState: {
                            getReport: state
                        }
                    })
                    break;
                default:
                    break;
            }            
        } else {
            if (type) {
                ClientClickContent(type)
            } else {
                ClientClickContent('关闭')
            }
            this.setState({
                dialogState: {}
            })
        }
    }
    uglyWoman = () => {
        const devURL = 'http://172.18.20.209:3001'
        const proURL = 'https://m.jjmmw.com/zt/hormats-report/'
        window.location = `${process.env.NODE_ENV==='production' ? proURL : devURL}?serialNo=${this.props.serialno}`
    }
    render() {
        const riskTextObj = riskMap[this.props.calc.risklevel - 1];
        const numberFormat = (this.props.calc.income > 0 ? '+' : '') + String(this.props.calc.income).replace(/(?!^)(?=(\d{3})+$)/g, ',')
        const numberFontSize = (() => {
            let length = numberFormat.length;
            if (length > 7) {
                return 650 / length;
            } else {
                return 90;
            }
        })();
        ClientFinishCalcAssetAllocation([
            this.props.calc.sharperatio,
            (this.props.calc.aror * 100).toFixed(2),
            (this.props.calc.maxdrawdown * 100).toFixed(2),
            riskTextObj.level,
            this.props.calc.income,
            this.props.calc.amount
        ])

        const compare = (a, b, c, d) => {
            let arr = [a, b, c, d]
            let maxValue = Math.max.apply(null, arr);
            return arr.indexOf(maxValue)
        }

        const sharperatioMaxIndex =  compare(this.props.calc.sharperatio,
            this.props.calc.sharperatioZl,
            this.props.calc.sharperatioHs300,
            this.props.calc.sharperatioSp500);

        const arorIndex =  compare(this.props.calc.aror,
            this.props.calc.arorZl,
            this.props.calc.arorHs300,
            this.props.calc.arorSp500);

        const maxdrawdownMaxIndex =  compare(this.props.calc.maxdrawdown,
            this.props.calc.maxdrawdownZl,
            this.props.calc.maxdrawdownHs300,
            this.props.calc.maxdrawdownSp500);
        
        return (
            <Body>
                <TitleWrapper pt={215} mb={110}>
                    <Title mainTitle='资产配置计算结果'></Title>
                </TitleWrapper>
                <MoneyWrapper>
                    <MoneyTitle>
                        <span></span>
                        <span>{riskTextObj.level}</span>
                        <span></span>
                    </MoneyTitle>
                    <MoneyText>{riskTextObj.text}根据您的资产配置金额及比例，您的投资收益为</MoneyText>
                    <MoneyMain>
                        <div>
                            <MoneyNumber fontSize={numberFontSize}>{numberFormat}</MoneyNumber>
                            <span>元</span>
                        </div>
                        {
                            !this.isIframe && <MoneyLink href="https://topm.jjmmw.com/special/m_zljb0002?utm_source=WeMedia&utm_medium=app&utm_term=hormats&utm_content=zcpzjsq&utm_campaign=ppxw">了解什么是资产配置</MoneyLink>
                        }
                    </MoneyMain>
                </MoneyWrapper>
                <SectionWrapper>
                    <TitleWrapper pt={215} mb={50}>
                        <Title mainTitle='指标对比'></Title>
                    </TitleWrapper>
                    <Contrast1>
                        <div className='th'>
                            <span>类别/指标</span>
                            <span onClick={this.dialogCentre.bind(this, true, 'ZBSM')}>夏普比率</span>
                            <span onClick={this.dialogCentre.bind(this, true, 'ZBSM')}>年化收益率</span>
                            <span onClick={this.dialogCentre.bind(this, true, 'ZBSM')}>最大回撤</span>
                        </div>
                        <div className='td'>
                            <span>您的配置</span>
                            {/* max传入false styled会抛错 */}
                            <IsMaxValue max={sharperatioMaxIndex === 0 ? 1 : 0}>{this.props.calc.sharperatio}</IsMaxValue>
                            <IsMaxValue max={arorIndex === 0 ? 1 : 0}>{(this.props.calc.aror * 100).toFixed(2) + '%'}</IsMaxValue>
                            <IsMaxValue max={maxdrawdownMaxIndex === 0 ? 1 : 0}>{(this.props.calc.maxdrawdown * 100).toFixed(2) + '%'}</IsMaxValue>
                        </div>
                        <div className='td'>
                            <span>众禄配置</span>
                            <IsMaxValue max={sharperatioMaxIndex === 1 ? 1 : 0}>{this.props.calc.sharperatioZl}</IsMaxValue>
                            <IsMaxValue max={arorIndex === 1 ? 1 : 0}>{(this.props.calc.arorZl * 100).toFixed(2) + '%'}</IsMaxValue>
                            <IsMaxValue max={maxdrawdownMaxIndex === 1 ? 1 : 0}>{(this.props.calc.maxdrawdownZl * 100).toFixed(2) + '%'}</IsMaxValue>
                        </div>
                        <div className='td'>
                            <span>沪深300</span>
                            <IsMaxValue max={sharperatioMaxIndex === 2 ? 1 : 0}>{this.props.calc.sharperatioHs300}</IsMaxValue>
                            <IsMaxValue max={arorIndex === 2 ? 1 : 0}>{(this.props.calc.arorHs300 * 100).toFixed(2) + '%'}</IsMaxValue>
                            <IsMaxValue max={maxdrawdownMaxIndex === 2 ? 1 : 0}>{(this.props.calc.maxdrawdownHs300 * 100).toFixed(2) + '%'}</IsMaxValue>
                        </div>
                        <div className='td'>
                            <span>标普500</span>
                            <IsMaxValue max={sharperatioMaxIndex === 3 ? 1 : 0}>{this.props.calc.sharperatioSp500}</IsMaxValue>
                            <IsMaxValue max={arorIndex === 3 ? 1 : 0}>{(this.props.calc.arorSp500 * 100).toFixed(2) + '%'}</IsMaxValue>
                            <IsMaxValue max={maxdrawdownMaxIndex === 3 ? 1 : 0}>{(this.props.calc.maxdrawdownSp500 * 100).toFixed(2) + '%'}</IsMaxValue>
                        </div>
                        <div className='tips'>数据区间：2006.01-2018.01</div>
                    </Contrast1>
                    <TitleWrapper pt={90} mb={50}>
                        <Title mainTitle='净值曲线对比'></Title>
                    </TitleWrapper>
                    <Contrast>
                        <ReactEcharts option={this.chartLineOption()}></ReactEcharts>
                    </Contrast>
                    <TitleWrapper pt={90} mb={50}>
                        <Title mainTitle='风险收益对比'></Title>
                    </TitleWrapper>
                    <Contrast>
                        <ReactEcharts option={this.chartBarOption()}></ReactEcharts>
                        <div className='tips'>数据区间：2006.01-2018.01</div>
                    </Contrast>
                    <TitleWrapper pt={90} mb={50}>
                        <Title mainTitle='分析说明'></Title>
                    </TitleWrapper>
                    <Contrast4>
                        <div>以上是2006年以来沪深300，美股标普500指数以及我们运用简单模型进行资产配置的结果。</div>
                        <div>沪深300代表了A股的走势，整体波动起伏非常大，在2006年以来虽然收益最大，但是风险也是最大的，不适宜进行单一资产配置。</div>
                        <div>美股经历近十年的牛市，但在2008年也损失惨重。</div>
                        <div>在长达12年的时间里，相对于单一资产投资，即使简单的资产配置模型也能取得更优的风险收益比。</div>
                    </Contrast4>
                    <BackButton onClick={this.backToCalculate}>返回重新计算 >></BackButton>
                    <FooterText>
                        声明：<br />
                        *本页面内容只作活动参考，不作为投资建议；<br />
                        *页面配置数据来源：众禄基金资产配置研究院；<br />
                        *本活动最终解释权归众禄基金公司所有；<br />
                        *市场有风险，投资需谨慎。
                    </FooterText>
                </SectionWrapper>
                <FooterButtonWrapper>
                    <FooterButton onClick={this.dialogCentre.bind(this, true, 'share')}>分享投资报告</FooterButton>
                    {/* {
                        this.scene ? <FooterButton orange onClick={this.dialogCentre.bind(this, true, 'submitRes')}>赢取现场红包666元</FooterButton> :
                        <FooterButton orange onClick={this.uglyWoman}>获取完整报告</FooterButton>
                    } */}
                </FooterButtonWrapper>
                {
                    this.state.dialogState.share && <DialogShare calc={this.props.calc} dialogCentre={this.dialogCentre}></DialogShare>
                }
                {
                    this.state.dialogState.submitRes && <DialogSubmitRes serialNo={this.props.calc.serialno} dialogCentre={this.dialogCentre}></DialogSubmitRes>
                }
                {
                    this.state.dialogState.ZBSM && <DialogZBSM dialogCentre={this.dialogCentre}></DialogZBSM>
                }
                {
                    this.state.dialogState.lucky && <DialogLucky dialogCentre={this.dialogCentre}></DialogLucky>
                }
                {/* {
                    this.state.dialogState.getReport && <DialogGetReport serialno={this.props.calc.serialno} dialogCentre={this.dialogCentre}></DialogGetReport>
                } */}
                {
                    this.state.dialogState.fail && <DialogFail dialogCentre={this.dialogCentre}></DialogFail>
                }
                {
                    this.state.dialogState.success && <DialogSuccess serialno={this.props.calc.serialno} dialogCentre={this.dialogCentre}></DialogSuccess>
                }
                <Toast></Toast>
            </Body>
        )
    }
}
